import axios from 'axios'
import { Component } from 'preact'
import InputGroup from '../../control-components/ui-components/InputGroup'
import ButtonControl from '../button-control'

interface Props {
  webmaster: string[]
  emails: string[]
  name: string
}

interface State {
  email: string
  name: string
  loading: boolean
}

interface WebmasterComponentProps extends Props {
  loading: boolean
  onChangeMail: (val: string) => void
  onChangeName: (val: string) => void
  setWebmaster: () => void
}

class WebmasterSetup extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      email: props.webmaster.length > 0 ? props.webmaster[0] : '',
      name: props.name,
      loading: false
    }
  }

  async setWebmaster() {
    this.setState({ loading: true })
    try {
      await axios.post('/settings/emailManagement/saveWebmaster', {
        email: this.state.email,
        name: this.state.name
      })
      this.setState({ loading: false })
      window.location.reload()
    } catch (e) {
      this.setState({ loading: false })
      console.log('e ', e)
    }
  }

  render() {
    if (this.props.emails.length === 0) {
      return null
    }
    return (
      <WebmasterComponent
        {...this.props}
        {...this.state}
        onChangeMail={(val: string) => this.setState({ email: val })}
        onChangeName={(val: string) => this.setState({ name: val })}
        setWebmaster={async () => await this.setWebmaster()}
      />
    )
  }
}

const WebmasterComponent = (props: WebmasterComponentProps) => (
  <div className='email-setup'>
    <h3>Email Setup</h3>

    <div className='form'>
      <div className='row'>
        <label for='webmaster'>Webmaster Email:</label>
        <InputGroup
          type='text'
          placeholder='eg: Insided Community'
          value={props.name}
          onChange={(e: { target: HTMLInputElement }) => props.onChangeName(e.target.value)}
        />
        <select
          className='webmasterSelector'
          onChange={(e) => props.onChangeMail((e.target as HTMLSelectElement).value)}
        >
          <option disabled selected={props.webmaster.length === 0}>
            Select your option
          </option>
          {props.emails.map((email, index) => (
            <option
              key={index}
              selected={props.webmaster.length > 0 && email === props.webmaster[0]}
            >
              {email}
            </option>
          ))}
        </select>
        <ButtonControl
          variant='success'
          title='Save'
          isLoading={props.loading}
          onClick={props.setWebmaster}
        />
      </div>
    </div>
  </div>
)

export { WebmasterComponent }
export default WebmasterSetup
